import $ from 'jquery'
import { closeModal } from '@/function/function.js';
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
import { openSelectOptions, selectOption, cr_state } from '@/select-box.js';
import ControleEspeces from '@/components/caisse/controle-especes'
import comptesApi from '@/api/comptabilite/_comptes'

Vue.use(VueHtml2pdf)


export default {
    name: 'caisse-versement',
    components: {
        ControleEspeces
    },
    props: [],
    data() {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,

            curr_state: cr_state,
            dest_selected: '',
            destination_id: 0,

            total_recettes: 0,
            total_depenses: 0,
            idUser: 1,
            date_versement: '',

            loading: false,

            solde_reel: 0, //  Solde réel (Solde compté physiquement, converti en devise principale)
            solde_theorique: 0, //  Solde théorique (Solde récupéré à partir de la somme des opérations ayant eu lieu)
            erreur_caisse: 0, //  Écart de caisse
            solde_cloture: 0, //  Solde de cloture
            montant_a_verser: 0, //  Montant à verser
            commentaire: '',
            total_versements_faits: 0,
            total_versements_recus: 0,

            solde_is_loading: true,
            save_loading: false,
            is_closing_cash_register: false,
            recap_check_loading: true,

            recap_controle_lignes: [],
            mobile_tickets: [],
            mobile_summary_error: ''
        }
    },
    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        /**
         * Solde disponible (Solde théorique)
         * @returns 
         */
        // total_solde() {
        //     return parseInt(this.total_recettes) + parseInt(this.total_versements_recus) - parseInt(this.total_depenses) - parseInt(this.total_versements_faits);
        // },

        userCompte() {
            return this.$store.getters["compteActiveUser"];
        },

        activeRole(){
            return this.$store.getters['activeRole'];
        },

        solde_disponible() {
            return this.$store.getters["solde_disponible"];
        },

        divers_info() {
            return this.$store.getters["divers_info"];
        },
        mobileTotalsParOperateur() {
            const groups = {}
            this.mobile_tickets.forEach(ticket => {
                const key = `${ticket.operateur_id}|${ticket.devise}`
                if (!groups[key]) groups[key] = { operateur: ticket.operateur, devise: ticket.devise, montant: 0 }
                groups[key].montant += Number(ticket.montant) || 0
            })
            return Object.values(groups)
        },
        totalMobileDisponible() {
            const primary = String(this.currency_info.principal_currency || '').toUpperCase()
            const secondary = String(this.currency_info.secondary_currency || '').toUpperCase()
            const rate = Number(this.currency_info.rate) || 0
            return this.mobile_tickets.reduce((total, ticket) => {
                const amount = Number(ticket.montant) || 0
                const currency = String(ticket.devise || primary).toUpperCase()
                return total + (currency === secondary && secondary !== primary ? amount * rate : amount)
            }, 0)
        },
        soldeTotalTheorique() {
            return (Number(this.solde_disponible) || 0) + this.totalMobileDisponible
        },
    },
    mounted() {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1 //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4 //  Caisse 1 (Infirmier)
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3 //  Comptabilité
            }
            // Destination
            if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.dest_selected = 'Caisse principale'
                this.destination_id = 1
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.dest_selected = 'Trésorerie'
                this.destination_id = 6
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.dest_selected = 'Banque'
                this.destination_id = 2
            }
        } else {
            this.$router.push({ "path": "/login" })
        }

        this.getSoldeDisponible()
        if (this.compte_id === 1) this.getMobilePaymentsForDeposit()

        $(document).bind('click', function(e) {
            let $clicked = $(e.target);
            this.curr_state = 0;
            if (!$clicked.parents().hasClass("select-box")) {
                $('.select-opts').removeClass('animate-fadeInRight');
                $('.select-opts').addClass('animate-fadeOutRight');
                $('.select-opts').fadeOut();
            }
        });

        this.date_versement = new Date()

        this.is_closing_cash_register = this.$store.getters['is_closing_cash']

        this.getDiversInfo()
    },
    methods: {
        async getMobilePaymentsForDeposit() {
            this.mobile_summary_error = ''
            try {
                const response = await comptesApi.getMobilePaymentsForDeposit()
                this.mobile_tickets = Array.isArray(response) ? response : []
            } catch (error) {
                this.mobile_summary_error = 'Le solde Mobile Money est momentanément indisponible.'
            }
        },
        getDiversInfo() {
            this.recap_check_loading = true
            this.$store.dispatch('getConfigInfoClinique', 'divers_info').then(() => {
                this.recap_check_loading = false
            })
        },

        getSoldeDisponible() {
            const data = {
                compte_id: this.compte_id,
                date: this.getDates().today_date,
                user_id: this.user_id
            }
            this.$store.dispatch("getSoldeDisponible", data).then(() => {
                this.solde_is_loading = false
            })
        },

        /**
         * Date
         * @returns 
         */
        getDates() {
            let today_date = new Date();
            let yesterday_date = new Date();
            yesterday_date.setDate(today_date.getDate() - 1);
            today_date = `${today_date.getFullYear()}-${today_date.getMonth() + 1}-${today_date.getDate()}`;
            yesterday_date = `${yesterday_date.getFullYear()}-${yesterday_date.getMonth()+1}-${yesterday_date.getDate()}`;
            return { today_date, yesterday_date };
        },

        /**
         * Mis à jour à chaque changement de comptage dans le composant controle-especes
         * (montant déjà converti en devise principale si l'établissement gère deux devises)
         * @param {*} total
         */
        onTotalChange(total) {
            this.clearError()
            this.solde_reel = total;
        },

        /**
         * Formatter le montant
         * @param {*} currency 
         */
        formatCurrency(currency) {
            return new Number(currency).toLocaleString("fr-FR");
        },

        /**
         * Recapitulatif du contrôle des espèces
         */
        recapControle() {
            let err = 0
            if (this.solde_reel == 0) {
                $('.err-msg-0').fadeIn()
                err++
            }

            if (err == 0) {
                // Calcul de l'erreur de caisse
                this.erreur_caisse = this.solde_reel > 0 ? this.solde_reel - this.solde_disponible : 0;

                // Récapitulatif du détail des coupures comptées, pour le rapport de versement
                this.recap_controle_lignes = this.solde_reel > 0 ? this.$refs.controle.getRecapLines() : [];

                $('.controle-espece').removeClass('animate-fadeInLeft');
                $('.controle-espece').addClass('animate-fadeOutLeft');
                $('.controle-espece').fadeOut();

                $('.recap-controle').fadeIn();
                $('.recap-controle').removeClass('animate-fadeOutLeft');
                $('.recap-controle').addClass('animate-fadeInRight');

                // L'ancien fonds de caisse était toujours fixé à zéro sur cet écran.
                this.montant_a_verser = this.solde_reel;

                if (this.solde_disponible > this.montant_a_verser) {
                    this.solde_cloture = this.solde_disponible - this.montant_a_verser
                } else {
                    this.solde_cloture = 0;
                }
            }
        },

        /**
         * Recompter les espèces 
         */
        recompterEspece() {
            $('.recap-controle').removeClass('animate-fadeInRight');
            $('.recap-controle').addClass('animate-fadeOutLeft');
            $('.recap-controle').fadeOut();

            $('.controle-espece').fadeIn();
            $('.controle-espece').removeClass('animate-fadeOutLeft');
            $('.controle-espece').addClass('animate-fadeInLeft');

            // >>>>     REMISE DES CONTROLE A 0    <<<<
        },

        async effectuerVersement() {
            this.save_loading = true;
            this.btn_disable = true
            let controle_argents = [];

            // RECAP CONTROLE DES BILLETS & PIECES
            (this.solde_reel > 0 ? this.$refs.controle.getDetailLines() : []).forEach((ligne) => {
                let contorle = ligne.prefix + '-' + ligne.nb + '-' + ligne.valeur + (ligne.role ? ('-' + ligne.role) : '')

                controle_argents.push(
                    contorle
                )
            })

            this.info_caissier = {
                nom_caissier: this.userCredentials.user.name,
                titre: this.userCredentials.user.titre
            }

            const data = {
                data_type: "versement",
                compte_id: this.compte_id,
                user_id: this.user_id,
                solde_au_versement: Number(this.solde_disponible) || 0,
                montant_verse: this.montant_a_verser,
                solde_cloture: parseInt(this.solde_cloture),
                destination: this.destination_id,
                commentaire: this.commentaire,
                ecart_caisse: this.erreur_caisse,
                controle_caisse: controle_argents,
                is_closing_cash_register: this.is_closing_cash_register,
                info_caissier: {
                    nom_caissier: this.userCredentials.user.name,
                    titre: this.userCredentials.user.titre
                }
            }
            try {
                const response = await this.$store.dispatch('doCaisseVersement', data)
                if (response.success) {
                    this.save_loading = false;
                    this.btn_disable = false
                    $('.modal').modal('hide')
                    this.$router.push({ path: '/clinicaa/comptabilite/caisse' })
                } else {
                    this.warningToast('Le versement n’a pas été enregistré. Vérifiez les montants et réessayez.')
                }
            } catch (error) {
                const message = error.response && error.response.data &&
                    (error.response.data.message || Object.values(error.response.data.errors || {})[0])
                this.warningToast(Array.isArray(message) ? message[0] :
                    (message || 'Le versement a échoué. Réessayez.'))
            } finally {
                this.save_loading = false;
                this.btn_disable = false
            }
        },

        /**
         * Continue et affiche le rapport de cloture de caisse
         */
        continuer() {
            let comment = $('#vrs-comment').val();
            let err = 0
            // CHAMP COMMENTAIRE OBLIGATOIRE  -  commenter si pas obligatoire
            if (this.erreur_caisse != 0 && (this.divers_info.show_recap_operation == 'Oui')) {
                if (comment == '') {
                    $('.err-msg-1').fadeIn(1000)
                    err++
                }
            }
            if(this.montant_a_verser == 0 || this.montant_a_verser == '') {
                $('.err-msg-2').fadeIn(1000)
                err++
            } else if(this.montant_a_verser > this.solde_reel) {
                $('.err-msg-3').fadeIn(1000)
                err++
            }

            if (err == 0) {
                this.commentaire = comment
                $('#rapport-cloture').modal('show')
            }
        },

        clearError() {
            for(let i = 0; i <= 3; i++) {
                $('.err-msg-'+i).fadeOut(500)
            }
        },

        /**
         * Format input to only digit
         * @param {*} selector 
         */
        async onlyDigit(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9]+/g, ''))
        },

        /**
         * Close Modal
         * @param {*} selector 
         */
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        /**
         * Show select options in dropdown
         * @param {int} j_state 
         * @param {string} selector 
         */
        async openSelectOption(j_state, selector) {

            this.curr_state = openSelectOptions.openSelectOption(j_state, selector)
        },

        /**
         * Select option in dropdown
         * @param {string} selected_value
         * @param {string} selected_id 
         * @param {string} selector 
         * @param {string} model_selector 
         */
        async selectOption(selected_value, selected_id, selector, model_selector) {
            this.curr_state = selectOption.chooseOption(selected_id, selector)

            switch (model_selector) {
                case 'dest':
                    this.dest_selected = selected_value;
                    break;
            }

            // Recupere la destination choisie
            this.destination_id = selected_id;
        },

        /**
         * Imprimer le rapport de versement
         */
        printRapport() {
            let comment = ''
            $('#r-comment').html(comment)
            this.$refs.html2Pdf.generatePdf()
        },
    }
}
